import { Icon } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ParseHtml from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ErrorContainer } from './';

export interface IErrorBoxProps {
	id?: string;
	message: string;
	show: boolean;
	showIcon?: boolean;
}
const ErrorPrefix = styled.div.attrs<{}>({})`
	 {
		font-weight: 600;
		display: inline-block;
	}
`;
ErrorPrefix.displayName = 'ErrorPrefix';
export const ErrorIcon = styled(Icon)`
	 {
		padding-right: 8px;
	}
`;
ErrorIcon.displayName = 'ErrorText';

export class ErrorMessage extends React.Component<IErrorBoxProps> {
	public render() {
		return (
			this.props.show && (
				<ErrorContainer id={this.props.id || ''}>
					{this.props.showIcon && <ErrorIcon name='error' />}
					<ErrorPrefix>{ContentConstants.ERROR}:</ErrorPrefix> {ParseHtml(this.props.message)}
				</ErrorContainer>
			)
		);
	}
}
